import angular from 'angular';

angular.module('cxTable').directive('cxSortColumn', [
  '$compile',
  function($compile) {
    return {
      restrict: 'A',
      require: '^^cxTable',
      scope: true,
      link: function(scope, element, attrs, table) {
        if (typeof attrs.key === 'undefined' || attrs.key.length <= 0) {
          console.warn('[cxSortColumn]: Missing "key" attribute');
          return;
        }
        /*Key attribute
         * Possible values:
         * name of property
         * array with names of properties
         * sort function (don't use with scroll tables)
         *
         * See orderByFilter: https://docs.angularjs.org/api/ng/filter/orderBy
         */
        if (!scope.key) scope.key = scope.$eval(attrs.key) || attrs.key || '';

        //Compare column key with the current table sorting, if it's the same show a caret icon.
        scope.sortVisible = function() {
          if (typeof scope.key === 'function' && typeof table.tableInfo.sortBy === 'function')
            return scope.key === table.tableInfo.sortBy;
          if (typeof scope.key === 'undefined' || typeof table.tableInfo.sortBy === 'undefined')
            return false;
          return angular.equals(scope.key, table.tableInfo.sortBy);
        };

        //Create and add caret icon to element
        var icon = angular.element(
          '<i class="fa fa-caret" ng-show="sortVisible()" ng-class="table.tableInfo.sortDesc?\'fa-caret-down\':\'fa-caret-up\'"></i>',
        );
        $compile(icon)(scope);
        element.prepend(icon);
        element.addClass('clickable').addClass('unselectable');
        element.bind('click', function() {
          //Sort column on click
          scope.$apply(table.sort(scope.key));
        });

        /* if cxSortColumn attribute is true => sort*/
        if (
          typeof attrs.cxSortColumn !== 'undefined' &&
          (typeof attrs.cxSortColumn !== 'string' || attrs.cxSortColumn !== '') &&
          !table.tableInfo.sortBy
        ) {
          table.sort(scope.key, !scope.$eval(attrs.cxSortColumn));
        }
      },
    };
  },
]);
